import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ClaimsService } from 'src/app/services/claims.service';

@Component({
  selector: 'app-success-claim',
  templateUrl: './success-claim.component.html',
  styleUrls: ['./success-claim.component.scss']
})
export class SuccessClaimComponent {
  message: string = "";
  constructor(@Inject(MAT_DIALOG_DATA) public data: string, private router: Router,
  private dialogRef: MatDialogRef<SuccessClaimComponent>, private _claimService: ClaimsService){}
  ngOnInit(){
    this.message = this.data;

  }
  closeDialog(){
    if(this.message.includes("save")){
      this._claimService.draftClaimTab.next("draft");
      this.router.navigate(['claims']);
    }else{
      this.router.navigate(['claims']);
    }
    this.dialogRef.close();
  }
  close(){
    this.dialogRef.close();
  }
}
